export default __webpack_public_path__ + "static/media/imperium-logo.03541884.png";